import { Component, OnInit }  from '@angular/core';
import { Router }             from '@angular/router';
import { environment } from '../../environments/environment';
import { Auth } from '../services/auth.service';
import { CountryService } from '../services/country/country.service';


import { DoctorService }  from '../services/doctors/doctor.service';
import { ProviderService } from '../services/providers/provider.service';


import { UsersComponent } from '../users/users.component';


@Component({
  moduleId: module.id,
  selector: 'my-doctors',
  templateUrl: 'doctors.component.html',
  styleUrls: [ '../users/users.component.css' ]
})

export class DoctorsComponent extends UsersComponent {

  timezone:string="America/Buenos_Aires"
  prod: boolean = environment.production

  enrollmentTypes = ["MP","MN","OP","ON", "CRM", "MM", "RM", "RP", "SPM", "CMP", "Lic.", "CP", "TP", "CI"]
  selectedEnrollmentType;

  selectedCountry: any = {
    name: ""
  }
  countries: any[];

  enrollmentProvs = [
    {id:"A", name:"Salta"},
    {id:"B", name:"Buenos Aires"},
    {id:"C", name:"Capital Federal" },
    {id:"D", name:"San Luis"},
    {id:"E", name:"Entre Ríos"},
    {id:"F", name:"La Rioja"},
    {id:"G", name:"Santiago del Estero"},
    {id:"H", name:"Chaco"},
    {id:"J", name:"San Juan"},
    {id:"K", name:"Catamarca"},
    {id:"L", name:"La Pampa"},
    {id:"M", name:"Mendoza"},
    {id:"N", name:"Misiones"},
    {id:"P", name:"Formosa"},
    {id:"Q", name:"Neuquén"},
    {id:"R", name:"Río Negro"},
    {id:"S", name:"Santa Fe"},
    {id:"T", name:"Tucumán"},
    {id:"U", name:"Chubut"},
    {id:"V", name:"Tierra del Fuego"},
    {id:"W", name:"Corrientes"},
    {id:"X", name:"Córdoba"},
    {id:"Y", name:"Jujuy"},
    {id:"Z", name:"Santa Cruz"},
    {id: "BR", name:"Brasil"},
    {id: "CO", name:"Colombia"},
    {id: "CE", name:"Ecuador"},
    {id: "ES", name:"España"},
    {id: "MX", name:"México"},
    {id: "PY", name:"Paraguay"},
    {id: "PE", name:"Perú"},
    {id: "PT", name:"Portugal"},
    {id: "UY", name:"Uruguay"},
  ];
  selectedEnrollmentProv;

  alertMessage = "You should check in on some of them.";

  auth0AdminId;
  enabledAdminToSendLadReports:any = environment.config.ENABLED_TO_SEND_LAD_REPORTS;
  canSendLadReports;
  hasWriteDoctorPermission:boolean = false;
  hasReportsPermission:boolean = false;
  constructor(
    protected router: Router,
    protected doctorService: DoctorService,
    protected authService: Auth,
    protected providerService:ProviderService,
    protected countryService:CountryService,
    protected auth: Auth) { super(router, doctorService,providerService); }


  protected getDetailUrl(): string {

    return '/doctor/' + this.selectedUser.id;
  };

  protected getCallDetailUrl(){
    return '/doctor/' + this.selectedUser.id + '/calls'
  }

  protected getUserString(): string {

    return 'doctor';
  };

  protected getUsersString(): string {

    return 'Doctores';
  };

  ngOnInit(): void {
    this.hasWriteDoctorPermission = this.auth.hasWriteDoctorPermission();
    this.hasReportsPermission = this.auth.hasReportsPermission();
    this.getUsers({ limit: this.usersPerGet })
    this.getCountries()
    this.auth0AdminId = this.authService.getAdminAuht0Id();
    this.enabledAdminToSendLadReports = this.enabledAdminToSendLadReports.split(",");
    this.canSendLadReports = this.enabledAdminToSendLadReports.includes(this.auth0AdminId);
  }

  add(): void {
    if (this.createCalled) {

      return;
    }
    if (this.newUser.firstName==undefined || this.newUser.lastName==undefined || this.newUser.password==undefined || this.newUser.email==undefined || this.newUser.enrollment==undefined || this.enrollmentTypes[this.selectedEnrollmentType]==undefined || this.enrollmentProvs[this.selectedEnrollmentProv]==undefined) {
      this.alertAdd=true;
      return;
    }
    let firstName = this.newUser.firstName.trim();
    if (!firstName) {
      this.alertAdd=true;
      this.alertMessage = "Missing doctor firstname. "
      return;
    }

    let lastName = this.newUser.lastName.trim();
    if (!lastName) {
      this.alertAdd=true;
      this.alertMessage = "Missing doctor lastname. "
      return;
    }

    let password = this.newUser.password.trim();
    if (!password || password.length < 8) {
      this.alertMessage = "Password should have more than 8 digits. "
      this.alertAdd=true;
      return;
    }

    let email = this.newUser.email.trim();
    if (!email) {
      this.alertMessage = "Missing doctor email. "
       this.alertAdd=true;
      return;
    }

    this.createCalled = true;


    this.userService.create({
      firstName: firstName,
      lastName: lastName,
      password: password,
      enrollment: this.newUser.enrollment,
      enrollmentProv: this.enrollmentProvs[this.selectedEnrollmentProv]['id'],
      enrollmentType: this.enrollmentTypes[this.selectedEnrollmentType],
      email: email,
      timezone:this.timezone
    })
      .then(user => {

        this.createCalled = false;
        this.users.push(user);
        this.selectedUser = null;
        this.newUser = {};
        this.alertCreated=true;
        return this;
      })
      .catch(error => {

        this.createCalled = false;
        alert("There was an error. Try with another email")
        return Promise.reject(error.message || error);
      });
  }

  status(){
    this.router.navigate([ '/doctors/status' ]);
  }

  sendReportToLadDoctors(){
    if (confirm("Are you really sure you want to create a report for each doctor?")) {
      let params = {}
      if (confirm("Do you want to send a copy to each doctor?"))
        params = {sendToDoctors: 'true'}
      this.doctorService.sendReportToLadDoctors(params)
      .then( () => alert("Reports sent successfully."))
      .catch( error => {
        if (error && error._body && error._body.message) alert(error._body.message);
      })
    }
  }

  getCountries(){
    this.countryService.getAll().then((countries) => {
      this.countries = countries;
    });
  }

  selectCountry(country) {
    this.selectedCountry = country
    this.term = this.selectedCountry.id
  }

}



// WEBPACK FOOTER //
// ./src/app/doctors/doctors.component.ts